import { getAnalyticsEventUrl } from '@core/api'
import { httpClient } from '@core/http-client'

import { type TEventForm } from '../types/eventFormTypes'

// The batch travels as a bare JSON array — the backend tells a batch from a single event by the
// presence of key `0`. `keepalive` on every batch, not only on the unload flush: the queue drains on
// a timer, so a navigation can cut into any POST, not just the last one.
export const sendEventsBatch = (events: TEventForm[]) =>
    httpClient.post(getAnalyticsEventUrl(), { json: events, keepalive: true })
